import MainRouter from 'router/MainRouter'
import TopBar from './TopBar'
import SideBar from './SideBar'

const Main = () => (
  <div className="w-full min-h-screen md:flex">
    <SideBar customClass='hidden md:block'  />
    <main className="min-w-0 flex-1">
      <TopBar />
      <MainRouter />
    </main>
  </div>
)

export default Main
